// extracted by mini-css-extract-plugin
export var fadeInOut = "_47-3";
export var icon = "_47-4";
export var savedIndicator = "_47-2";
export var savingIndicator = "_47-0";
export var spin = "_47-1";